import { createSlice } from '@reduxjs/toolkit';
import { AssetReceiptState } from './assetReceiptTypes';
import { 
  createReceipt, 
  fetchReceipts, 
  fetchReceiptById, 
  updateReceipt, 
  deleteReceipt 
} from './assetReceiptActions';

const initialState: AssetReceiptState = {
  receipts: [],
  selectedReceipt: undefined,
  loading: false,
  error: undefined,
};

const assetReceiptSlice = createSlice({
  name: 'assetReceipt',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Receipt
      .addCase(createReceipt.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createReceipt.fulfilled, (state, action) => {
        state.loading = false;
        state.receipts.push(action.payload);
      })
      .addCase(createReceipt.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Receipts
      .addCase(fetchReceipts.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchReceipts.fulfilled, (state, action) => {
        state.loading = false;
        state.receipts = action.payload;
      })
      .addCase(fetchReceipts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Receipt by ID
      .addCase(fetchReceiptById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchReceiptById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedReceipt = action.payload;
      })
      .addCase(fetchReceiptById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Receipt
      .addCase(updateReceipt.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateReceipt.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.receipts.findIndex(receipt => receipt.id === action.payload.id);
        if (index !== -1) {
          state.receipts[index] = action.payload;
        }
      })
      .addCase(updateReceipt.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Receipt
      .addCase(deleteReceipt.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteReceipt.fulfilled, (state, action) => {
        state.loading = false;
        state.receipts = state.receipts.filter(receipt => receipt.id !== action.payload.id);
      })
      .addCase(deleteReceipt.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default assetReceiptSlice.reducer;
